<span *ngIf="messages.length">{{ messages[0] }}</span>
